var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"keywordChartModal",attrs:{"id":"keyword-chart-modal","title":_vm.modalTitle,"modal-class":"keyword-chart--modal","hide-footer":"","size":"lg"}},[_c('BarChart',{staticClass:"mb-4",attrs:{"styles":{'height' : '300px'},"options":_vm.chartOptions,"chart-data":_vm.keywordChartData,"chart-id":"keyword-chart"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }